import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

import { AuthStore } from '../../../../auth';

@Component({
  selector: 'remote-update-domain-user-menu',
  imports: [MatMenu, MatMenuTrigger, MatMenuItem],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './user-menu.html'
})
export class UserMenu {
  authStore = inject(AuthStore);

  userInitials = this.authStore.userInitials();
  accountInfo = this.authStore.accountInfo();
  userFullName = this.authStore.userFullName();
  userEmail = this.authStore.userEmail();

  handleLogout() {
    this.authStore.logout();
  }
}
